import main from 'locales/main';

export default {
  ...main
}
